"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateExtendedRID = exports.generateRID = void 0;
const uuid_1 = require("uuid");
/**
 * Generates a RID based on the specified options.
 * @param options, an object of type {@link RIDGenerationOptions}
 * @returns A `string` RID generated based on the options passed.
 *
 * Examples:
 * ```TS
 * // Returns 'sharefile:account-123/feed-456'
 * generateRID({baseEntityId: '123',entityType:'feed', entityId:'456'})
 *
 * // Returns 'someothersystem:account-123'
 * generateRID({system:'someothersystem', baseEntityId:'123'});
 *
 * // Returns 'sharefile:publisher-123'
 * generateRID({baseEntityType:'publisher', baseEntityId: '123'})
 *
 * // Returns 'sharefile:publisher-123/feed-456'
 * generateRID({system:'sharefile',baseEntityType:'publisher', baseEntityId:'123', entityType:'feed', entityId:'456'})
 *
 * ```
 */
const generateRID = (options) => {
    const { system = 'sharefile', baseEntityType = 'account', baseEntityId, entityType, entityId = (0, uuid_1.v4)() } = options;
    return `${system.toLowerCase()}:${baseEntityType.toLowerCase()}-${baseEntityId}${entityType ? `/${entityType.toLowerCase()}-${entityId}` : ''}`;
};
exports.generateRID = generateRID;
/**
 * Use this helper to extend an existing RID.
 * @param options, an object of type {@link ExtendedRIDGenerationOptions}
 * @returns A RID that extends your provided `baseRID` (see {@link ExtendedRIDGenerationOptions.baseRID}) with a RID fragment for the provided (see {@link ExtendedRIDGenerationOptions.entityType}).
 *
 * Example:
 * ```TS
 *
 * // Returns 'sharefile:account-123/project-456/requestlist-789'
 * generateExtendedRID({baseRID: 'sharefile:account-123/project-456',entityType:'requestlist',entityId:'789'})
 * ```
 */
const generateExtendedRID = (options) => {
    const { baseRID, entityType, entityId = (0, uuid_1.v4)() } = options;
    return `${baseRID}/${entityType.toLowerCase()}-${entityId}`;
};
exports.generateExtendedRID = generateExtendedRID;
//# sourceMappingURL=generate.js.map